import styled from 'styled-components'

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
`

export const Select = styled.select`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[3]};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    background-color: ${({ theme }) => theme.colors.background.bg1};
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: ${({ theme }) => theme.typography.fontSize.sm};

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.success};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.success}25;
    }
`

export const ErrorMessage = styled.div`
    margin-top: ${({ theme }) => theme.spacing[4]};
    padding: ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.colors.error}15;
    border: 1px solid ${({ theme }) => theme.colors.error}30;
    border-radius: ${({ theme }) => theme.borderRadius.md};
    color: ${({ theme }) => theme.colors.error};
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
`

export const ConfirmDeleteSection = styled.div`
    margin-top: ${({ theme }) => theme.spacing[4]};
    padding: ${({ theme }) => theme.spacing[4]};
    background-color: ${({ theme }) => theme.colors.error}10;
    border: 1px solid ${({ theme }) => theme.colors.error}30;
    border-radius: ${({ theme }) => theme.borderRadius.md};
`

export const ConfirmText = styled.p`
    margin: 0 0 ${({ theme }) => theme.spacing[3]} 0;
    color: ${({ theme }) => theme.colors.text.primary};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`

export const ConfirmButtons = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[3]};
    justify-content: flex-end;
    margin-top: ${({ theme }) => theme.spacing[3]};
`

export const SubSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[3]};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`

export const SubSectionTitle = styled.h3`
    font-size: ${({ theme }) => theme.typography.fontSize.lg};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
`

export const SubSectionDescription = styled.span`
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    color: ${({ theme }) => theme.colors.text.secondary};
    margin-bottom: ${({ theme }) => theme.spacing[2]};
`

export const SubSectionLabel = styled.label`
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    color: ${({ theme }) => theme.colors.text.primary};
    margin-bottom: ${({ theme }) => theme.spacing[2]};
    display: block;
`

export const ToggleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
`

export const ToggleLabel = styled.label`
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    color: ${({ theme }) => theme.colors.text.primary};
    cursor: pointer;
`

export const ToggleInput = styled.input`
    width: 18px;
    height: 18px;
    cursor: pointer;
`

export const CategoryListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    max-height: 400px;
    overflow-y: auto;
    padding: ${({ theme }) => theme.spacing[2]};
    border: 1px solid ${({ theme }) => theme.colors.greyScale[300]};
    border-radius: ${({ theme }) => theme.borderRadius.md};
`

export const CategoryListItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme }) => theme.spacing[2]};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    background-color: ${({ theme }) => theme.colors.background.bg1};

    &:hover {
        background-color: ${({ theme }) => theme.colors.background.bg2};
    }
`

export const CategoryInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[1]};
    flex: 1;
`

export const CategoryName = styled.div`
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    color: ${({ theme }) => theme.colors.text.primary};
`

export const CategoryDesc = styled.div`
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
    color: ${({ theme }) => theme.colors.text.secondary};
`
